import { render } from "./CapacityDashboard.vue?vue&type=template&id=1065321b&scoped=true"
import script from "./CapacityDashboard.vue?vue&type=script&lang=js"
export * from "./CapacityDashboard.vue?vue&type=script&lang=js"

import "./CapacityDashboard.vue?vue&type=style&index=0&id=1065321b&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1065321b"]])

export default __exports__